<template>
  <div :class="isWidget ? 'tool-widget' : 'tool-page'">
    <div class="tool-content">
      <div v-if="!isWidget" class="tool-heading">
        <div>
          <h2>视频去重</h2>
          <p>上传视频并选择去重模式，快速生成原创视频</p>
        </div>
        <app-icon  class="app-icon" name="content_cut"></app-icon>
      </div>

      <div class="tool-card">

      <!-- 上传区域 -->
        <section class="section-block upload-section">
          <div class="section-header upload-header">
            <span class="section-title">上传视频</span>
            <el-button v-if="!isWidget" type="text" size="small" class="record-button" @click="$router.push('/user2/record')">
              <i class="el-icon-time"></i> 制作记录
            </el-button>
          </div>
          <qhyuploadv2 ref="upload" :limit="uploadLimit"></qhyuploadv2>
        </section>

      <!-- 模式加载骨架 -->
      <template v-if="modesLoading">
        <section class="section-block">
          <div class="section-title">预设方案</div>
          <div class="chip-row skeleton-row">
            <span v-for="n in 4" :key="'y' + n" class="skeleton-chip"></span>
          </div>
        </section>
        <section class="section-block">
          <div class="section-title">模式选择</div>
          <div class="chip-row skeleton-row">
            <span v-for="n in 8" :key="'m' + n" class="skeleton-chip"></span>
          </div>
        </section>
      </template>

      <!-- 预设方案 -->
      <section class="section-block" v-if="yushe.length > 0">
        <div class="section-header">
          <span class="section-title">预设方案</span>
          <span class="section-action" @click="saveYushe">保存选择</span>
        </div>
        <div class="chip-row">
          <div v-for="(item, index) in yushe" :key="index" class="chip" :class="{ active: yusheIndex === index }"
            @click="applyYushe(index, item)">
            {{ item.name }}
          </div>
        </div>
      </section>

      <!-- 模式选择 -->
      <section class="section-block" v-if="ms_modes.length > 0">
        <div class="section-header">
          <span class="section-title">模式选择</span>
        </div>
        <div class="chip-row">
          <div v-for="(item, index) in ms_modes" :key="index" class="chip"
            :class="{ active: msCheck.includes(item.url) }" @click="toggleMode(item.url)">
            {{ item.name }}
          </div>
        </div>
      </section>

      <!-- 附加选择 -->
      <section class="section-block" v-if="msOther.length > 0">
        <div class="section-header">
          <span class="section-title">附加选择</span>
        </div>
        <div class="chip-row">
          <div v-for="(item, index) in msOther" :key="index" class="chip"
            :class="{ active: msCheck.includes(item.value) }" @click="toggleMode(item.value)">
            {{ item.name }}
          </div>
        </div>
      </section>

      <!-- 裂变数量 -->
      <section class="section-block" v-if="!isWidget">
        <div class="section-header">
          <span class="section-title">裂变数量</span>
        </div>
        <div class="setting-inline">
          <span class="setting-label">单个视频制作数量:</span>
          <el-input-number v-model="xgcs" :min="1" :max="100" size="mini"></el-input-number>
        </div>
      </section>

      <!-- 提交按钮 -->
      <button class="btn-submit" @click="startProcess" :disabled="processing">
        <app-icon v-if="processing"  class="app-icon spinning" name="progress_activity"></app-icon>
        <app-icon v-else  class="app-icon" name="play_arrow"></app-icon>
        {{ processing ? '处理中...' : '开始去重' }}
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import qhyuploadv2 from '@/components/common/qhyuploadv2.vue'

export default {
  name: 'QcPage',
  components: { qhyuploadv2 },
  props: {
    limit: { type: Number, default: 0 }
  },
  data() {
    return {
      processing: false,
      modesLoading: true,
      uploadLimit: 200,
      ms_modes: [],
      msOther: [],
      msCheck: [],
      yushe: [],
      yusheIndex: null,
      xgcs: 1,
    }
  },
  computed: {
    isWidget() {
      return this.limit > 0
    }
  },
  methods: {

    // ── 模式 API ──
    loadModes() {
      this.modesLoading = true
      this.$ajax.post('api/v1/tasks/ms').then(res => {
        const body = res.data
        if (body && body.status === 200) {
          this.ms_modes = body.data || []
          this.msOther = body.other || []
          this.yushe = body.yushe || []
          // 默认选中第一个模式
          if (this.ms_modes.length > 0 && this.msCheck.length === 0) {
            this.msCheck = [this.ms_modes[0].url]
          }
        }
      }).catch(() => {
        this.$msg.error('获取模式列表失败')
      }).finally(() => {
        this.modesLoading = false
      })
    },

    // ── 模式选择 ──
    toggleMode(key) {
      // 主模式（url 在 ms_modes 中）之间互斥，附加选择可多选
      const isMainMode = this.ms_modes.some(m => m.url === key)
      if (isMainMode) {
        const mainUrls = this.ms_modes.map(m => m.url)
        this.msCheck = this.msCheck.filter(k => !mainUrls.includes(k))
      }
      const set = new Set(this.msCheck)
      set[set.has(key) ? 'delete' : 'add'](key)
      this.msCheck = [...set]
    },

    // ── 预设方案 ──
    applyYushe(index, item) {
      this.yusheIndex = index
      this.msCheck = [...item.list]
    },
    saveYushe() {
      if (this.msCheck.length === 0) {
        this.$msg.warning('请先选择模式')
        return
      }
      const name = '方案' + (this.yushe.length + 1)
      this.yushe.push({ name, list: [...this.msCheck] })
      this.$msg.success('已保存: ' + name)
    },

    // ── 开始去重 ──
    startProcess() {
      const urls = this.$refs.upload.get_urls(1)
      if (urls.status === 100) {
        this.$msg.error(urls.msg)
        return
      }
      if (this.msCheck.length === 0) {
        this.$msg.error('请选择模式')
        return
      }
      this.processing = true
      const urlText = urls.map(u => u.url || u).join('\n')
      const data = {
        url: urlText,
        ms: this.msCheck.join(''),
        xgcs: this.xgcs,
        type: 'qc'
      }
      this.$ajax.post('api/v1/users/makevideo', data).then(res => {
        console.log(res)
        if (res.data && res.data.status === 200) {
          this.$msg.success(res.data.msg || '任务已提交')
          this.$refs.upload.clear_url()
        } else {
          this.$msg.error(res.data.msg || '提交失败')
        }
      }).catch(() => {
        this.$msg.error('提交失败，请稍后重试')
      }).finally(() => {
        this.processing = false
      })
    }
  },
  created() {
    this.loadModes()
  }
}
</script>

<style scoped>
/* ===== 上传区域 ===== */
.upload-section {
  margin-bottom: 24px;
}

.record-button {
  padding: 0;
}

/* ===== 分区 ===== */
.section-block {
  margin-top: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.section-action {
  font-size: 12px;
  color: #1a73e8;
  cursor: pointer;
}

/* ===== Chip 选择 ===== */
.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  padding: 6px 14px;
  background: #eaeaea;
  border-radius: 6px;
  font-size: 13px;
  color: #5a5a5a;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.chip:hover {
  background: #dde;
}

.chip.active {
  background: #1a73e8;
  color: #ffffff;
}

/* ===== 裂变数量 ===== */
.setting-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.setting-label {
  font-size: 13px;
  color: #1a1a2e;
}

/* ===== 提交按钮 ===== */
.btn-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 24px;
  background: #1a73e8;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 24px;
}

.btn-submit:hover:not(:disabled) {
  background: #1557b0;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ===== 组件模式 ===== */
.qc-widget .widget-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qc-widget .section-block {
  margin-top: 12px;
}

.qc-widget .btn-submit {
  width: 100%;
  padding: 10px;
}

/* ===== 页面模式 ===== */
.qc-page {
  --c-bg: #f5f7fa;
  --c-card: #ffffff;
  --c-text: #1a1a2e;
  --c-border: #e5e7eb;
  font-family: 'Inter', -apple-system, sans-serif;
}

.qc-page .qc-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
}

.qc-page .intro-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
  border-radius: 16px;
  color: #ffffff;
  margin-bottom: 24px;
}

.intro-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

.intro-icon .app-icon {
  font-size: 28px;
}

.intro-text h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.intro-text p {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
}

.qc-page .btn-submit {
  display: flex;
  width: 100%;
  padding: 14px;
  font-size: 16px;
  border-radius: 10px;
}

/* 响应式 */
@media (max-width: 640px) {
  .qc-page .qc-content {
    padding: 16px;
  }
}

/* ===== 与视频去重 V2 统一的 2.0 页面样式 ===== */
.tool-page {
  min-height: 100%;
  padding: 24px 24px 48px;
  background: #f5f7fa;
  box-sizing: border-box;
}

.tool-widget {
  box-sizing: border-box;
}

.tool-widget .tool-card {
  padding: 0 0 24px;
  border: 0;
  box-shadow: none;
}

.tool-widget .section-block:first-child .section-title {
  display: none;
}

.tool-content {
  max-width: 1080px;
  margin: 0 auto;
}

.tool-page .tool-content {
  padding-bottom: 48px;
}

.tool-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.tool-heading h2 {
  margin: 0 0 6px;
  color: #1e293b;
  font-size: 22px;
}

.tool-heading p {
  margin: 0;
  color: #94a3b8;
  font-size: 13px;
}

.tool-heading > span {
  padding: 11px;
  border-radius: 12px;
  background: #e8f1fe;
  color: #1a73e8;
  font-size: 28px;
}

.tool-card {
  padding: 24px 24px 48px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, .04);
}

.tool-card > .section-block {
  margin-top: 0;
}

.tool-card > .section-block + .section-block {
  margin-top: 26px;
}

.tool-card .section-header {
  margin-bottom: 0;
}

.tool-card .section-header.upload-header {
  margin-bottom: 15px;
}

.tool-card .section-title {
  margin-bottom: 12px;
  color: #1e293b;
}

.tool-card .upload-header .section-title {
  margin-bottom: 0;
}

.tool-card .chip {
  min-width: 76px;
  padding: 8px 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  box-sizing: border-box;
}

.tool-card .chip:hover {
  border-color: #93c5fd;
  background: #f8fafc;
  color: #1a73e8;
}

.tool-card .chip.active {
  border-color: #1a73e8;
  background: #1a73e8;
  color: #fff;
}

.tool-card .btn-submit {
  width: 100%;
  margin-top: 30px;
  padding: 12px 20px;
  border-radius: 4px;
}

/* 模式加载骨架 */
.skeleton-row { display: flex; flex-wrap: wrap; gap: 8px; }
.skeleton-chip {
  width: 76px;
  height: 34px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef1f5 25%, #f8fafc 50%, #eef1f5 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
}
@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 768px) {
  .tool-page {
    padding: 14px 14px 32px;
  }

  .tool-card {
    padding: 16px 16px 32px;
  }

  .tool-page .tool-content {
    padding-bottom: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Qc.vue